import React from 'react'
import {auth} from '../firebase.js'

function Nav({user}) {
    return (
        <header className="header">
            <div className="title">🔥 Chatify</div>
            {user && <button className="signout" onClick={()=> auth.signOut()}>Sign out</button>}     
        </header>
    )
}

export default Nav;
